export const cguContentSelector = (state) => state.cguContent.data;
export const cguContentFetchStatusSelector = (state) => state.cguContent.fetchStatus;
export const cguContentUpdateStatusSelector = (state) => state.cguContent.updateStatus;
